<template>
  <dl class="attributes">
    <ProgramDetail
      v-for="({ name, value }) in attributes"
      :key="name"
      :name="name"
      class="attribute"
    >
      <TextDelta
        class="value"
        v-text="value"
      />
    </ProgramDetail>
  </dl>
</template>

<script>
  import TextDelta from './TextDelta';
  import ProgramDetail from './ProgramDetail';

  export default {
    components: {
      TextDelta,
      ProgramDetail,
    },
    props: {
      attributes: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .attribute {
    @include column;

    padding: spacing(base-gamma);
    background-color: color(white);

    @include breakpoint(tablet) {
      width: 200px;
    }

    & + & {
      margin-top: spacing(base-gamma);

      @include breakpoint(tablet) {
        margin-top: 0;
        margin-left: spacing(base-gamma);
      }
    }
  }

  .attributes {
    display: flex;
    flex-direction: column;

    @include breakpoint(tablet) {
      flex-direction: row;
    }
  }

  .value {
    display: block;
    min-height: 1.8rem * 2;
    color: color(red);
  }
</style>
